export enum AlertRoles {
    CANCEL = "cancel",
    DELETE = "delete",
    UPDATE = "update",
    CONFIRM = "confirm"
}
